const binding = { modules: {}, dataActions: {} };

    (binding.modules['page-container'] = {
        c: () => require('partner/modules/page-container/page-container.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'page-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/page-container'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|page-container|page-container'] = {
                c: () => require('partner/modules/page-container/page-container.view.tsx'),
                cn: '__local__-__local__-page-container'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };